import React, { useEffect, useState } from 'react'
import { ListGroup, ListGroupItem } from 'react-bootstrap'
import Loading from '../../component/Loading/Loading'
import Notify from '../../services/Notify'
import UserService from '../../services/UserService'

export default function ReadpointUsersAccessSelect({ updateUsers, selectedUsers }) {

  const [users, setUsers] = useState(false)

  const userService = new UserService()

  const addOrRemoveItem = (userId) => {
    selectedUsers.includes(userId) ? 
    updateUsers(selectedUsers.filter(x => x !== userId)) : 
    updateUsers([...selectedUsers, userId])
  }

  useEffect(() => {
    async function getAllUsers() {
      try {
        const requestSize = 5000

        return setUsers((await userService.findAll(requestSize)).content)
      } catch (error) {
        Notify.error('Erro ao buscar usuários', error)
      }
    }
    getAllUsers()
  }, [])

  return (
    !users ? <Loading /> :
      <ListGroup>
        {
          users.map((x, i) => {
            return (
              <ListGroupItem key={i} 
                active={selectedUsers.includes(users[i].id)}
                onClick={() => addOrRemoveItem(users[i].id)}
              >
                <h5>{x.name}</h5>
              </ListGroupItem>
            )
          })
        }
      </ListGroup>
  )
}



// WEBPACK FOOTER //
// ./src/readpoint/component/ReadpointUserAccessSelect.js